import DeaconTheme from "./js/deacon-theme";

require("./style/stylesheets/styles.scss");

const theme = new DeaconTheme();
theme.init();
